module.exports = __webpack_public_path__ + "img/Screenshot from 2020-09-19 10-12-32.4a75d74d.png";